module.exports = __webpack_public_path__ + "img/wf-check-list.10f4f761.svg";